
import { Vue, Component, Prop } from 'vue-property-decorator';
import Forecast from '@/ui/components/devices/mpc/ConsumptionService/SettingsCharts/Forecast.vue';
import Charts from '@/ui/components/devices/mpc/ConsumptionService/SettingsCharts/Charts.vue';

/**
 * Component that represent wrapper for charts tabs navigation.
 * Used in ConsumptionService.
 */
@Component({
  components: {
    Forecast,
    Charts,
  },
})
export default class SettingsCharts extends Vue {
  @Prop() mpcId!: any;
  @Prop({ default: null }) chartsScaling!: any;
  @Prop({
    default: {
      actualPower: '',
      calculatedPower: null,
      calculatedEnergy: null,
      calculatedEnergy2: null,
    },
  }) mqttChartsVariables!: any;

  tab: any = null

  get langPath() {
    return 'mlModel.ConsumptionService.settingsView.chartTabs';
  }

  get tabs() {
    return [
      {
        title: 'chart',
        locale: this.langPath,
        component: 'Charts',
        chartsScaling: this.chartsScaling,
        mqttChartsVariables: this.mqttChartsVariables,
      },
      {
        title: 'forecast',
        locale: this.langPath,
        component: 'Forecast',
        chartsScaling: this.chartsScaling,
        mpcId: this.mpcId,
      },
    ];
  }
}
